import { TextResource } from '@Utilities/TextResource';

export class Form
{
	public Element: HTMLFormElement;
	public Errors: string[];
	public ShowErrorHeader: boolean;

	constructor(form: HTMLFormElement)
	{
		this.Element = form;
		this.Errors = [];
		this.ShowErrorHeader = true;
		this.BindValidation();
	}

	public BindValidation = (): void =>
	{
		this.Element.addEventListener("submit", this.SubmitListener);
	};

	public ClearErrors = (): void =>
	{
		const errorList = this.Element.querySelector(".alert.error");

		if (errorList !== null)
		{
			errorList.remove();
		}

		this.Errors = [];
	};

	public DisplaySuccess = (message: string): void =>
	{
		const successHtml = `<div class="alert alert-success mb-0" style="max-width: 400px" role="alert">
			<svg class="svg-inline--fa me-3" aria-hidden="true"><use xlink:href="#fa-solid-fa-circle-check"></use></svg>${message}
		</div>`;

		this.Element.innerHTML = successHtml;
	};

	public ListErrors = (): void =>
	{
		const errorDiv = document.createElement("div");
		const errorUl = document.createElement("ul");
		let errorList = "";
		errorDiv.setAttribute("class", "alert alert-danger error");
		errorDiv.setAttribute("role", "alert");

		if (this.ShowErrorHeader === true)
		{
			const errorHeader = document.createElement("h5");
			errorHeader.setAttribute("class", "alert-heading");
			errorHeader.textContent = TextResource.GetTextByCulture("Feature_Form_Error");
			errorDiv.append(errorHeader);
		}

		this.Errors.forEach((error) =>
		{
			errorList += `<li>${error}</li>`;
		});

		errorUl.innerHTML = errorList;
		errorDiv.append(errorUl);

		this.Element.prepend(errorDiv);
	};

	public SubmitHandler = (): void =>
	{
	};

	private SubmitListener = (e: Event): void =>
	{
		e.preventDefault();

		const valid = this.ValidateForm();

		if (valid == true)
		{
			this.SubmitHandler();
		}
	};

	public ValidationHandler = (): boolean =>
	{
		return false;
	};

	public ValidateForm = (): boolean =>
	{
		this.ClearErrors();
		const valid = this.ValidationHandler();

		if (valid == true)
		{
			return true;
		}
		else
		{
			this.ListErrors();
			return false;
		}
	};
}